export * from './ScrolledAttributeSelector';
//# sourceMappingURL=index.js.map